import { ComponentStateVars } from "./component-state-vars";
import { PersistenceScope } from "./persistence-scope";

export class StateVar<T>{
    public key: string;
    public currentValue: T;
    public initialValue: T;
    public persistenceScope: PersistenceScope
    constructor(stateVarSettings: ComponentStateVars<T>){
      this.key = stateVarSettings.key;
      this.initialValue = stateVarSettings.initialValue;
      this.persistenceScope = stateVarSettings.persistenceScope;
    }
  }
